export enum LOADING_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
}

export enum NETWORK {
  main = 'mainnet-beta',
  devnet = 'devnet',
  testnet = 'testnet',
}

export enum ROUTES {
  KINO = '/',
  NOT_FOUND = '*',
}
